import styled from 'styled-components';
import { Typography } from 'antd';
import { ClockCircleOutlined, CalendarOutlined, EyeOutlined, ScheduleOutlined, CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { AssignmentStatus, getTranslatedTypeName } from '@module/assignment';
import { SubmissionOverviewStatusComponent, getTranslatedSubmissionOverviewStatusName } from '../submission-overview-status.component';
import { CardSupportText, CardTitle, getColor, getColorBySubmissionStatus, getSize, SecondaryButton, styleVariables } from '@lib/common';
import { getDateTime } from '../utils';
import { AssignmentTypeTag } from '../table-participated-assignment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Text = Typography.Text;
var AssignmentCard = styled.div.withConfig({
  displayName: "participated-assignment-list-itemcomponent__AssignmentCard",
  componentId: "sc-16du4u3-0"
})(["background-color:", ";border-radius:", ";padding:", ";transition:all 0.3s;border:1px solid ", ";box-shadow:0 1px 3px 0 rgba(0,0,0,0.05);display:flex;align-items:center;margin-bottom:", ";&:hover{box-shadow:0 4px 12px rgba(0,0,0,0.08);border-color:", ";}"], getColor('fillBgWhite'), getSize('radiusSm'), getSize('padding20'), getColor('fillIntSubActive'), getSize('padding16'), getColor('fillIntActive'));
var CardInner = styled.div.withConfig({
  displayName: "participated-assignment-list-itemcomponent__CardInner",
  componentId: "sc-16du4u3-1"
})(["width:100%;display:flex;align-items:center;justify-content:space-between;gap:", ";"], getSize('padding24'));
var MainContent = styled.div.withConfig({
  displayName: "participated-assignment-list-itemcomponent__MainContent",
  componentId: "sc-16du4u3-2"
})(["display:flex;align-items:center;gap:", ";flex:1;"], getSize('padding20'));
var StatusIconBox = styled.div.withConfig({
  displayName: "participated-assignment-list-itemcomponent__StatusIconBox",
  componentId: "sc-16du4u3-3"
})(["width:40px;height:40px;border-radius:", ";display:flex;align-items:center;justify-content:center;font-size:", ";", ""], getSize('radiusSm'), getSize('typo20'), function (_ref) {
  var statusType = _ref.statusType;
  return getColorBySubmissionStatus(statusType);
});
var CardHeader = styled.div.withConfig({
  displayName: "participated-assignment-list-itemcomponent__CardHeader",
  componentId: "sc-16du4u3-4"
})(["display:flex;flex-direction:column;gap:", ";"], getSize('padding8'));
var CardMetaRow = styled.div.withConfig({
  displayName: "participated-assignment-list-itemcomponent__CardMetaRow",
  componentId: "sc-16du4u3-5"
})(["display:flex;align-items:center;gap:", ";flex-wrap:wrap;"], getSize('padding12'));
var DetailItem = styled.div.withConfig({
  displayName: "participated-assignment-list-itemcomponent__DetailItem",
  componentId: "sc-16du4u3-6"
})(["display:flex;align-items:center;gap:", ";font-size:", ";color:", ";.anticon{font-size:", ";}"], getSize('padding12'), getSize('typo13'), getColor('textIntSub'), getSize('typo14'));
var IdTag = styled.span.withConfig({
  displayName: "participated-assignment-list-itemcomponent__IdTag",
  componentId: "sc-16du4u3-7"
})(["font-size:12px;color:", ";font-weight:500;display:flex;align-items:center;"], getColor('textIntSub'));
var SubmittedCount = styled.div.withConfig({
  displayName: "participated-assignment-list-itemcomponent__SubmittedCount",
  componentId: "sc-16du4u3-8"
})(["display:flex;flex-direction:column;align-items:center;justify-content:center;min-width:80px;text-align:center;"]);
var SubmittedLabel = styled.div.withConfig({
  displayName: "participated-assignment-list-itemcomponent__SubmittedLabel",
  componentId: "sc-16du4u3-9"
})(["font-size:10px;font-weight:600;letter-spacing:0.05em;text-transform:uppercase;color:", ";margin-top:2px;"], getColor('textIntSub'));
var ActionsSection = styled.div.withConfig({
  displayName: "participated-assignment-list-itemcomponent__ActionsSection",
  componentId: "sc-16du4u3-10"
})(["display:flex;align-items:center;justify-content:flex-end;min-width:120px;"]);

var getStatusIcon = function getStatusIcon(statusType) {
  switch (statusType) {
    case AssignmentStatus.ACTIVE:
      return /*#__PURE__*/_jsx(CheckOutlined, {});

    case AssignmentStatus.DELETED:
      return /*#__PURE__*/_jsx(CloseOutlined, {});

    default:
      return /*#__PURE__*/_jsx(ClockCircleOutlined, {});
  }
};

export var ParticipatedAssignmentListItemComponent = function ParticipatedAssignmentListItemComponent(_ref2) {
  var _record$type, _record$type2, _record$type3, _record$type4;

  var record = _ref2.record,
      columnLabels = _ref2.columnLabels,
      navigateToSubmissionDetail = _ref2.navigateToSubmissionDetail;
  var endTimeText = record.endTime ? getDateTime(+record.endTime) : 'No set date';
  var statusType = record.report.status.id;
  var submittedCount = record.report.totalSubmittedSubmission >= 0 ? record.report.totalSubmittedSubmission : 0;
  return /*#__PURE__*/_jsx(AssignmentCard, {
    children: /*#__PURE__*/_jsxs(CardInner, {
      children: [/*#__PURE__*/_jsxs(MainContent, {
        children: [/*#__PURE__*/_jsx(StatusIconBox, {
          statusType: statusType,
          children: getStatusIcon(statusType)
        }), /*#__PURE__*/_jsxs(CardHeader, {
          children: [/*#__PURE__*/_jsxs(CardMetaRow, {
            children: [/*#__PURE__*/_jsx(SubmissionOverviewStatusComponent, {
              statusType: record.report.status.id,
              text: getTranslatedSubmissionOverviewStatusName(record.report.status.id, columnLabels)
            }), /*#__PURE__*/_jsxs(IdTag, {
              children: ["#", record.idNumber]
            }), /*#__PURE__*/_jsx(AssignmentTypeTag, {
              typeId: (_record$type = record.type) === null || _record$type === void 0 ? void 0 : _record$type.id,
              typeName: getTranslatedTypeName((_record$type2 = record.type) === null || _record$type2 === void 0 ? void 0 : _record$type2.id, (_record$type3 = record.type) === null || _record$type3 === void 0 ? void 0 : _record$type3.name, columnLabels)
            })]
          }), /*#__PURE__*/_jsx(CardTitle, {
            children: record.title
          }), /*#__PURE__*/_jsx(CardMetaRow, {
            style: {
              marginTop: 2
            },
            children: /*#__PURE__*/_jsxs(DetailItem, {
              children: [/*#__PURE__*/_jsx(ClockCircleOutlined, {}), /*#__PURE__*/_jsxs(Text, {
                style: {
                  fontSize: '14px',
                  color: styleVariables.colors.gray11
                },
                children: ["Duration:", ' ', ((_record$type4 = record.type) === null || _record$type4 === void 0 ? void 0 : _record$type4.name) === columnLabels.assignmentTypePractice ? 'Unlimited' : '30 Minute']
              })]
            })
          }), /*#__PURE__*/_jsxs(CardMetaRow, {
            style: {
              marginTop: 2
            },
            children: [/*#__PURE__*/_jsxs(DetailItem, {
              children: [/*#__PURE__*/_jsx(CalendarOutlined, {}), /*#__PURE__*/_jsx(CardSupportText, {
                children: record.createdAt ? "Start: ".concat(getDateTime(+record.createdAt)) : ''
              })]
            }), /*#__PURE__*/_jsxs(DetailItem, {
              children: [/*#__PURE__*/_jsx(ScheduleOutlined, {}), /*#__PURE__*/_jsxs(CardSupportText, {
                children: ["End: ", endTimeText]
              })]
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs(SubmittedCount, {
        children: [/*#__PURE__*/_jsx("div", {
          style: {
            fontSize: '20px',
            fontWeight: 700,
            color: styleVariables.colors.gray13
          },
          children: submittedCount
        }), /*#__PURE__*/_jsx(SubmittedLabel, {
          children: columnLabels.statusSubmitted
        })]
      }), /*#__PURE__*/_jsx(ActionsSection, {
        children: navigateToSubmissionDetail && /*#__PURE__*/_jsxs(SecondaryButton, {
          style: {
            borderRadius: '8px',
            padding: '0 16px',
            height: '36px'
          },
          onClick: function onClick() {
            return navigateToSubmissionDetail(record.id.toString());
          },
          children: [/*#__PURE__*/_jsx(EyeOutlined, {}), columnLabels.clickToViewDetail]
        })
      })]
    })
  });
};